var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2em",
    height: "2em",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.949 49.104c-5.475 6.583-13.726 10.774-22.957 10.774C13.51 59.878.148 46.516.148 30.032c0-15.57 11.92-28.355 27.13-29.725v4.546C14.569 6.218 4.67 16.981 4.67 30.055c0 14 11.348 25.349 25.346 25.349 7.708 0 14.612-3.441 19.26-8.871l3.673 2.571z",
    fill: "#003F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.026 44.634a29.713 29.713 0 0 0 3.81-14.602c0-15.57-11.92-28.355-27.131-29.725v4.541c12.734 1.343 22.657 12.116 22.657 25.207 0 4.343-1.092 8.43-3.016 12.002l3.68 2.577z",
    fill: "#009FDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.598478d51f59ff4e7d84925943f9949e.svg";
export { ForwardRef as ReactComponent };